import dayjs from 'dayjs';
import { IsNotEmpty, IsNotNullOrUndefined } from '../Helpers';
import { DevelopmentItem, DevelopmentPlan, ImprovementPlan } from '../models/dtos';
import ApiBase from './base/ApiBase'
import { ApiResponse, ApiResponseContent } from '../models/custom-models';
import { DevelopmentPlanItemFilter } from './TalentClient';

class DevelopmentClient extends ApiBase {
    private controllerName: string = 'Talent';
    private subControllerName: string = 'Development';

    async Create(dto: CreateDevelopmentItem, signal?: AbortSignal): Promise<ApiResponseContent<string>> {
        return this.PostAsync(`${this.subControllerName}`, dto, signal);
    }

    async Complete(id: string, completedContext: CompleteDevelopmentItemContext, signal?: AbortSignal): Promise<ApiResponse> {
        return this.PutAsync(`${this.subControllerName}/${id}/Complete`, completedContext, signal);
    }

    async Delete(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.subControllerName}/${id}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<ApiResponseContent<DevelopmentItem>> {
        return this.GetAsync(`${this.subControllerName}/${id}`, signal);
    }

    async GetDevelopmentItems(id: string, filter?: DevelopmentPlanItemFilter, signal?: AbortSignal): Promise<ApiResponseContent<DevelopmentItem[]>>{
        let url = `${this.controllerName}/${id}/${this.subControllerName}/DevelopmentItems`;

        if (IsNotNullOrUndefined(filter))
            url = `${url}?filter=${filter}`;

        return this.GetAsync(url, signal);
    }
    
    async BuildDevelopmentPlan(id: string, dto: ImprovementPlan, signal?: AbortSignal): Promise<ApiResponseContent<DevelopmentPlan>> {
        return this.PostAsync(`${this.controllerName}/${id}/Development/DevelopmentPlan`, dto, signal);
    }

    async BuildImprovementPlan(id: string, signal?: AbortSignal): Promise<ApiResponseContent<ImprovementPlan>> {
        return this.GetAsync(`${this.controllerName}/${id}/Development/ImprovementPlan`, signal);
    }

    static CreateDefault = (): DevelopmentItem => {
        return {
            Id: '',
            TalentId: '',
            ProficiencyId: '',
            Title: '',
            Narrative: '',
            StartDate: '',
            CompleteDate: ''
        }
    }

    static RuleStartDateBeforeToday = (startDate: string): boolean => dayjs(startDate) < dayjs();
    static RuleItemCompleted = (completeDate: string): boolean => IsNotEmpty(completeDate); 

};

export interface CreateDevelopmentItem {
    TalentId: string;
    ProficiencyId: string;
    Title: string;
    Narrative: string;
    StartDate: any;
}

export interface CompleteDevelopmentItemContext{
    CompletedDate: string;
}
    
export enum DevelopmentItemErrors {
    Create = 'Error creating Development Item',
    Delete = 'Error deleting Development Item',
    GetAll = 'Error loading Development Items',
    GetSingle = 'Error loading Development Item',
    Update = 'Error saving Development Item',
    Complete = 'Error completing Development Item'
};

export default DevelopmentClient;